import React, { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import Card, { Kicker } from "./brand/Surface";
import Action from "./brand/Action";
import Mark from "./brand/Mark";

export default function NotFound() {
  useEffect(() => {
    document.title = "Niet gevonden · Casper De Bock";
  }, []);

  return (
    <Card
      tone="solid"
      pad="lg"
      className="mx-auto flex min-h-[420px] max-w-[600px] flex-col items-center justify-center text-center"
    >
      <Mark size={48} decorative />

      <Kicker className="mt-8 text-muted">404</Kicker>
      <h1 className="text-[clamp(28px,6vw,44px)] text-fg">Dit stuk is eruit gevallen.</h1>
      <p className="mx-auto mt-3 max-w-[38ch] text-body">
        Die pagina bestaat niet. Wat wel bestaat: een hoop projecten die wel afgeraakt zijn.
      </p>

      <div className="mt-8 flex flex-wrap justify-center gap-2">
        <Action to="/" variant="accent">
          <ArrowLeft aria-hidden className="size-4" strokeWidth={2} />
          Naar start
        </Action>
        <Action
          to="/projects"
          variant="ghost"
        >
          Bekijk het werk
        </Action>
      </div>
    </Card>
  );
}
